import { useEffect } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useTheme } from '@/theme';
import {
  applyInboxOAuthRedirectResult,
  coerceQueryString,
} from '@/navigation/inboxOAuthReturnRoute';
import { completeOAuthWebSession } from '@/utils/completeOAuthWebSession';

/**
 * Inbox Gmail OAuth redirects to tripvio://gmail-callback?success=true | error=… (see gmailOAuthCallback).
 * This route must exist or Expo Router shows "Unmatched Route" and traps the navigation stack behind trip-detection.
 */
export default function GmailInboxOAuthCallbackRoute() {
  const theme = useTheme();
  const router = useRouter();

  const params = useLocalSearchParams<{ success?: string | string[]; error?: string | string[] }>();
  const successFlag = coerceQueryString(params.success);
  const errorMsg = coerceQueryString(params.error);

  useEffect(() => {
    void (async () => {
      completeOAuthWebSession();
      const success = successFlag === 'true';
      await applyInboxOAuthRedirectResult('gmail', success, errorMsg ?? null);
      if (success) {
        router.replace({ pathname: '/trip-detection', params: { provider: 'gmail' } });
      } else {
        router.replace('/');
      }
    })();
  }, [router, successFlag, errorMsg]);

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: theme.colors.background,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ActivityIndicator size="large" color={theme.colors.primary} />
    </View>
  );
}
